import { GET_INTERCOM_ACTION } from '~/src/store/actionTypes/intercom';
import { IntercomActionInfo } from '~/src/store/reducers/intercom';

export const saveIntercomAction = (actionInfo: IntercomActionInfo) => ({
    type: GET_INTERCOM_ACTION,
    payload: actionInfo,
});
